export default class CloseTopicsMenu {
  constructor(context) {
    this.context = context;
  }

  run(params) {
    this.context.analytics.track('Topics Menu Closed', params);
  }
}
